export const validateInputs = (
  data: Record<string, string | number>,
  requiredFields: Record<string, boolean>
) => {
  const errors: Record<string, string> = {};

  Object.keys(data).forEach((key) => {
    const isRequired = requiredFields[key] !== false;

    const value = data[key];
    const valueString = String(value).trim();

    if (isRequired && !valueString) {
      errors[key] = "Este campo es obligatorio.";
    }
  });

  return errors;
};

export const validateCheckboxSelection = (selectedValues: any[]): string | null => {
  if (!selectedValues || selectedValues.length === 0) {
    return "Debes seleccionar al menos una opción.";
  }
  return null;
};

export const getColorClass = (value: number): string => {
  if (value > 0) return "text-link-visited";
  if (value < 0) return "text-text-error";
  return "";
};